import styled from "styled-components";
import { ButtonLink } from "../../../core/layout/button/button.elements"

export const BouttonConnexion = styled(ButtonLink)`
  display: block;
  margin: 0 auto !important;
  width: 50% !important;
`;